import * as api from '../contactApi';
import { businessEntityActionCreators } from '../../businessEntity';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  contactActionCreators,
  ContactActionKeys,
  IContact,
  UpdateContact
  } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { uiActionCreators } from '../../ui';

function* updateContactSaga(action: UpdateContact) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IEntityWithMessages<IContact> = yield call(api.updateContact, action.payload);

  if (response.value) {
    yield put(contactActionCreators.processContacts([response.value]));
    yield put(businessEntityActionCreators.addContacts([response.value]));
  }

  if (response.messages.length > 0 || response.error) {
    let title: string = `The following validation problems need to be fixed to save this contact:`;

    if (response.error) {
      title = 'There was a problem saving this contact.  Please rety.';
    }
    yield put(
      uiActionCreators.showMessageDialog({
        messages: response.messages,
        title
      })
    );
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateContact() {
  yield takeEvery(ContactActionKeys.UPDATE_CONTACT, updateContactSaga);
}
